import { useQuery } from "react-query";
import { fetchDynamicZipcodeMapData } from "./api";

export function useDynamicZipcodeMap(filters, options={}) {
    return useQuery(["dynamicZipcodeMap", filters], () => fetchDynamicZipcodeMapData(filters), {
      staleTime: 60000 * 60, 
      ...options
    })
  }